import {
    CALENDAR_PLAYERS_ROUTE,
    CALENDAR_PLAYER_CHEATERS_ROUTE,
    CALENDAR_FILTER_PLAYERS_ROUTE,
    CALENDAR_PLAYER_ADVERTISING_CLICK_ROUTE,
    DOWNLOAD_EXPORT_ROUTE,
    CALENDAR_DELETE_ALL_PLAYERS,
    PSEUDONONYMIZE_PLAYER_ROUTE
} from './constants';
import http from '../../../utils/httpService';
import { getCookie } from '../../../utils/cookieService';

/**
 *
 * @param calendarID
 */
const requestCalendarPlayers = calendarID => {
    const route = CALENDAR_PLAYERS_ROUTE + `/${ calendarID }`;
    return http.request( route, 'GET' );
};
/**
 *
 * @param calendarID
 * @param from
 * @param to
 * @param hatchId
 */
const requestCalendarPlayersFilter = ( calendarID, from, to, hatchId ) => {
    const data = {
        from: from,
        to: to,
        hatch_Id: hatchId
    };

    const route = CALENDAR_FILTER_PLAYERS_ROUTE + `/${ calendarID }`;
    return http.request( route, 'POST', data );
};
/**
 *
 * @param id
 * @param calendarID
 * @param from
 * @param to
 * @param hatchId
 */
const requestDeleteUserPlayer = ( id, calendarID, from, to, hatchId ) => {
    const data = {
        player_id: id,
        cheatersable_id: calendarID,
        cheatersable_type: 'calendar',
        from: from,
        to: to,
        hatch_Id: hatchId
    };
    return http.request( CALENDAR_PLAYER_CHEATERS_ROUTE, 'POST', data );
};

const requestPseudononymizeUserPlayer = ( player_id, calendar_id ) => {
    const data = {
        player_id: player_id,
        calendar_id: calendar_id
    };
    return http.request( PSEUDONONYMIZE_PLAYER_ROUTE, 'POST', data );
};

/**
 *
 * @param itemType
 * @param hatchId
 * @param link
 */
const requestSendClickAdvertising = ( itemType, hatchId, link ) => {
    const uuid = getCookie( 'uuid' );
    const data = {
        uuid_front: uuid,
        adv: itemType,
        hatch_id: hatchId,
        external_url: link
    };
    return http.request( CALENDAR_PLAYER_ADVERTISING_CLICK_ROUTE, 'POST', data );
};
/**
 *
 * @param calendarID
 * @param hatchId
 */
const requestExportFile = (calendarID, hatchId) => {
    const route = DOWNLOAD_EXPORT_ROUTE + `/${ calendarID }/players`;
    const data = {
        hatch_id: hatchId
    };
    return http.request( route, 'POST', data );
};
/**
 *
 * @param calendarID
 * @param typeData
 * @param withPlayers
 * @param resolve
 */
const requestCalendarDeleteAllUserPlayer = ( calendarID, typeData, withPlayers, resolve ) => {
    const route = CALENDAR_DELETE_ALL_PLAYERS + `/${ calendarID }`;
    const data = { data: typeData, withPlayers: withPlayers };
    return http.request( route, 'POST', data, null, resolve );
};

export {
    requestCalendarPlayers,
    requestDeleteUserPlayer,
    requestPseudononymizeUserPlayer,
    requestCalendarPlayersFilter,
    requestSendClickAdvertising,
    requestExportFile,
    requestCalendarDeleteAllUserPlayer
};